module.exports = __webpack_public_path__ + "static/img/quanyi@2x.94c686f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopIntr/shop/quanyi@2x.png
// module id = /Fs1
// module chunks = 18